<div class="container-fluid form-container  p-0 m-0 ">
  <div class="row h-100 g-0 min-vh-100">
    <div
      class="col-md-6  d-flex align-items-center justify-content-center bg-light position-relative min-vh-100 left-hero">
      <img 
      ngSrc="/assets/images/trace-image.png" 
      width="700" 
      height="600"
      priority
      alt="hero image"
      class="hero-img"
    />
    </div>
    <div class="col-md-6 col-12 form-section d-flex align-items-center position-relative">
      <div class="w-100">
        <div class="form-box mx-auto">
          <div >
            <div class="top mb-3">
              <h1 class="text-brand-purple" > <b>Create New  <br> Password</b></h1>
              <h6 class="text-gray">
                Your new password must be different from previous used passwords.
              </h6>
               <span class="invalid-feedback" *ngIf="tokenExpireError">{{
                 tokenExpireError
                  }} Please go to <a class="forgot-password fw-light  text-brand-purple" [routerLink]="['/forgot-password']">Forgot</a></span>
            </div>
            <form class="position-relative"  [formGroup]="resetForm"
              (ngSubmit)="onSubmit()">
              <div class="mb-2 position-relative">
                <label for="email">New Password <span class="text-danger">*</span></label>
                <div class="position-relative">
                <input [type]="showConfirmPassword ? 'text' : 'password'" appFilledInput
                  class="form-control shadow-none rounded-12 "  formControlName="newPassword"  id="confirmPassword">
                <img [src]="showConfirmPassword ? 'assets/icons/eye-strike.svg' :  'assets/icons/eye.svg'" alt="eye"
                  width="18" class="position-absolute top-12" (click)="toggleConfirmPassword()">
                  </div>
                   <span class="invalid-feedback" *ngIf="resetForm.get('newPassword')?.errors?.['serverError'] ">{{
                  resetForm.get('newPassword')?.errors?.['serverError'] 
                  }} </span>
              </div>
              <div class="mb-2">
                <label for="password">Confirm Password <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input [type]="showPassword ? 'text' : 'password'"  appFilledInput
                    class="form-control shadow-none rounded-12" formControlName="confirmPassword" id="password">
                  <img [src]="showPassword ? 'assets/icons/eye-strike.svg' : 'assets/icons/eye.svg'"
                    (click)="togglePassword()" alt="eye" width="18" class="position-absolute top-12">
                    <div class="invalid-feedback" *ngIf="resetForm.get('confirmPassword')?.errors?.['serverError'] as errors ">
                  <div *ngFor="let err of errors">{{ err }}</div>
                 </div>
                </div>
              </div>
              <br />
              <button type="submit" class="btn bg-brand-purple text-white w-100 rounded-12  mb-4"
                [disabled]="utility.hasEmptyFields(resetForm) || loader()">
                <app-spinner [loader]="loader()"></app-spinner>
                <span *ngIf="!loader()">
                Reset Password
                </span>
              </button>
            </form>
          </div>
        </div>
        <p class="text-center small footer-text position-absolute bottom-0 start-0 end-0 text-brand-dark-purple mb-2">2025 Trace.
          All rights reserved.</p>
      </div>
    </div>
  </div>
</div>